export enum EPlayerType {
  HLS = 'hls',
  WEBRTC = 'webrtc',
  NATIVE = 'native',
  BROADCAST = 'broadcast',
}

export enum EPlaybackState {
  IDLE = 'idle',
  LOADING = 'loading',
  PAUSED = 'paused',
  PLAYING = 'playing',
  ERROR = 'error',
}

export enum EPlaybackStartType {
  WAITING = 'waiting',
  AUTO = 'auto',
  MANUAL = 'manual',
}

export type TPlayerType = `${EPlayerType}`;

export type TMediaStream = string | MediaStream | MediaSource;

export interface IPlayerState {
  canPlay: boolean;
  isLoading: boolean;
  isDestroyed: boolean;
  isError: boolean;
  isAutoplayError: boolean;
  isPaused: boolean;
  isPlaying: boolean;
  isRestarted: boolean;
  isStalled: boolean;
  isWaiting: boolean;
  stream?: TMediaStream;
  videoElement?: HTMLVideoElement | null;
  canvasElement?: HTMLCanvasElement | null;
  ownContainer?: HTMLDivElement | null;
  videoPlaybackState: EPlaybackState;
  volume?: number;
  videoElementResolution?: {
    height: number;
    width: number;
  };

  /**
   * Flag that indicates that the stream has once started in the current instance of the class.
   */
  startedPlaying: boolean;
}

export enum ECommonEvent {
  BROADCAST_STATE_CHANGED = 'commonEvents.broadcastStateChanged',
  BROADCAST_REMOTE_STATS_AVAILABLE = 'commonEvents.broadcastRemoteStatsAvailable',
  PLAYING_STATE_CHANGED = 'commonEvents.playingStateChanged',
  COMMON_ERROR = 'commonEvents.commonError',
}

export type TCommonEvents = {
  [ECommonEvent.COMMON_ERROR]: {
    error: {
      domain: string;
      message: string;
      info: string;
    };
  };
};

export type TCommonEventPayload<T extends keyof TCommonEvents> = TCommonEvents[T];
